<div class="basicrow lessm">
    <div class="container">
        <div class="autowcont m-top">
            <div class="basicrow msidespad">
                <div class="b-title">
                    <div class="autocont f-black roboto-m f-bmed pull-left vcenter">
                        <div class="tabcell">
                            Balance en Prepago
                        </div>
                    </div>
                </div>
            </div>
            <div class="basicrow msidespad m-top-u-i">
                <div class="balancesptr-ii fortimes-a text-center">
                    <span class="roboto-b">
                        N&uacute;mero de Tel&eacute;fono
                    </span><br />
                    <span class="f-black f-big roboto-b">
                        <div class="basicrow">
                            <select [(ngModel)]="this.subscriber" (change)="this.refreshDataTo($event)" class="sel-f">
                                <option *ngFor="let list of this.subscribers" [ngValue]="list.subscriberNumberField">{{list.subscriberNumberField}}
                                </option>
                            </select>
                        </div>
                    </span>
                </div>
                <div class="balancesptr-ii fortimes-a h-nobrd-i text-center">
                    <span class="roboto-b">
                        Balance en Prepago
                    </span><br />
                    <span id="balance_line_prepago" class="f-red f-lsemi roboto-b">
                        {{this.billBalanceField.replace(',', '')|currency}}
                    </span>
                </div>
                <div class="balancesptr-ii-b fortimes-a text-center">
                    <span class="roboto-b">
                        Pr&oacute;xima Recarga
                    </span><br/>

                    <span id="next_date_line_prepago" class="f-black f-big roboto-b">
                       {{this.endDateField}}
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>